import {gql, useMutation, MutationHookOptions} from '@apollo/client';
import {LoginMutation} from '../types/graphql';

export const LOGIN = gql`
  mutation Login {
    login {
      id
      roles
    }
  }
`;

/**
 * Hook for login mutation.
 */
export const useLogin = (opts?: MutationHookOptions<LoginMutation>) =>
  useMutation<LoginMutation>(LOGIN, opts);
